import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

export default {
  title: 'Components/Hint',
  component: 'a1-hint',
  parameters: {
    docs: {
      description: {
        component: 'Partial Component - Informative text',
      },
    },
    layout: 'centered',
  },
  tags: ['autodocs'],
};

const elementName = 'a1-hint';

const Template = (args: Components.A1Hint): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Default: Story<Components.A1Hint> = Template.bind({});
Default.args = {
  text: 'This is a hint.',
};

export const Disabled: Story<Components.A1Hint> = Template.bind({});
Disabled.args = {
  ...Default.args,
  state: 'disabled',
};
